import { Injectable } from '@angular/core';
import { ApiService } from '../../services/data/api.service';
import { Observable } from 'rxjs';
import { IForgotPasswordModel } from '../../models/account/forgot-password.model';
import { ResetPasswordModel } from '../../models/account/reset-password.model';
import { throwError } from 'rxjs';

@Injectable()
export class ResetPasswordService {
    public error: any;
    public hasError: boolean;

    constructor(private apiService: ApiService) { }

    public get(code: string): Observable<ResetPasswordModel> {
        this.hasError = false;
        return this.apiService.get(`api/ResetPassword?code=${code}`);
    }
    public post(model: ResetPasswordModel): Observable<Boolean> {
        this.hasError = false;
        return this.apiService.post(`api/ResetPassword`, model, true);
    }

    public setUserPassword(model: ResetPasswordModel): Observable<Boolean> {
        this.hasError = false;
        return this.apiService.post<ResetPasswordModel, Boolean>(`api/ResetPassword/SetUserPassword`, model, true);
    }

    private handleError(error) {
        this.hasError = true;
        let msg = `Status Code ${error.status} on url ${error.url}`;
        console.error(msg);
        return throwError(msg); // Observable.throw(msg);
    }
}